/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import * as Yup from 'yup';

import { KubernetesIdentifier } from 'shared';

import { CreateProjectFormValues } from './CreateProjectOverlay.types';

export const initialFormValues: CreateProjectFormValues = {
  name: '',
  description: '',
  organizationId: undefined,
  organization: undefined,
  thumbnail: null,
  thumbnailsOptions: [],
};

export const validationSchema = Yup.object({
  name: Yup.string()
    .trim()
    .min(KubernetesIdentifier.MinLength, 'min_length')
    .max(KubernetesIdentifier.MaxLength, 'max_length')
    .matches(KubernetesIdentifier.Regex, 'invalid')
    .required('empty'),
  description: Yup.string().trim().nullable().max(200, 'max_length'),
  organization: Yup.mixed().required('empty'),
  thumbnailsOptions: Yup.mixed(),
});
